import React from 'react'
import { motion } from "motion/react"

const SkillDetail = ({ imgsrc, alt, text }) => {
  return (
    <motion.div
      whileHover={{ y: -3, borderColor: "var(--color-signal-500)" }}
      transition={{ type: "spring", stiffness: 300, damping: 30 }}
      className="flex items-center gap-2 rounded-md border border-ink-800 bg-ink-900 px-3 py-2"
    >
      <img className="h-5 w-5 object-contain" src={imgsrc} alt={alt} />
      <p className="font-mono text-xs text-mist-100">{text}</p>
    </motion.div>
  )
}

export default SkillDetail
